// API Configuration
// In production (tatvamasi.ca), use same origin. Otherwise use REACT_APP_BACKEND_URL
const isProduction = typeof window !== 'undefined' && window.location.hostname === 'tatvamasi.ca';
const API_BASE = isProduction ? "" : (process.env.REACT_APP_BACKEND_URL || "");
export const API = `${API_BASE}/api`;

// Build version for debugging
// Picnic 2026 event active, Vishu hidden
export const BUILD_VERSION = "2026.06.18.001";

export default API;
